

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Database } from '../database';
import { NL_Siparis } from '../../models/NL_Siparis';

@Injectable()
export class BllSiparisDetay extends Database {
  constructor() {
    super("NL_Siparis");
  }

  siparisDetayEkle_Temp(kaynakRef: number, itemref: number, miktar: number, urunAdi: string, kdv: number, siparisID: number, urunfiyati: number, urunmaliyet: number, siparisdurumid: number, kalan: number) {
    return new Promise((resolve, reject) => {
      var siparisDetay = new NL_Siparis();
      siparisDetay.CariKartID = kaynakRef;
      siparisDetay.Kdv = kdv;
      siparisDetay.Miktar = miktar;
      siparisDetay.siparisID = siparisID;
      siparisDetay.BirimFiyat = urunfiyati;
      siparisDetay.DepoKodu = 1;
      siparisDetay.IslemTuru = 1;
      siparisDetay.Sign = 1;
      siparisDetay.SlsMan = "Mobil";
      siparisDetay.Tutar = miktar * urunfiyati;
      siparisDetay.StokKartID = itemref;
      siparisDetay.Maliyet = urunmaliyet;
      siparisDetay.NetFiyat = urunfiyati * kdv / 100
      siparisDetay.UrunName = urunAdi;
      siparisDetay.SIPARIS_DURUM_ID = siparisdurumid;
      siparisDetay.Kalan=kalan;
  
      this.add(siparisDetay).then(a => {
        resolve(a);
      }).catch(x => {
        reject(x);
      })

    });
  }
  alisfaturasiDetayEkle_Temp(StokKartID: number, CariKartID: number, Miktar: number, BirimFiyat: number, Tutar: number,
    KdvOran: number, NetFiyat: number, SiparisID: number, UrunAdi: string, SipariDurumID: number, islemyapan) {
    return new Promise((resolve, reject) => {
      var kalem = new NL_Siparis();
      var oranconvert: number = 0;
      oranconvert = 1 * KdvOran / 100 + 1
      kalem.CariKartID = CariKartID;
      kalem.AraTutar = BirimFiyat;
      kalem.Kdv = Tutar * oranconvert - BirimFiyat;
      kalem.Miktar = Miktar;
      kalem.siparisID = SiparisID;
      kalem.BirimFiyat = BirimFiyat;
      kalem.DepoKodu = 0;
      kalem.IslemTuru = 2;
      kalem.Sign = 1;
      kalem.SlsMan = islemyapan;
      kalem.Tutar = Tutar * oranconvert;
      kalem.StokKartID = StokKartID;
      kalem.NetFiyat = Tutar * oranconvert;
      kalem.UrunName = UrunAdi;
      kalem.IskontoOran1 = 0;
      kalem.IskontoOran2 = 0;
      kalem.IskontoOran3 = 0;
      kalem.IskontoTutar = 0;
      kalem.IskontoluBirimFiyati = 0;
      kalem.KdvOran = KdvOran;
      kalem.SIPARIS_DURUM_ID = SipariDurumID;
      this.add(kalem).then(a => {
        resolve(a);
      }).catch(x => {
        reject(x);
      })

    });
  }
  satisfaturasiDetayEkle_Temp(StokKartID: number, CariKartID: number, Miktar: number, BirimFiyat: number, Tutar: number,
    KdvOran: number, NetFiyat: number, SiparisID: number, UrunAdi: string, SipariDurumID: number, islemyapan) {
    return new Promise((resolve, reject) => {
      var kalem = new NL_Siparis();
      var oranconvert: number = 0;
      oranconvert = 1 * KdvOran / 100 + 1
      kalem.CariKartID = CariKartID;
      kalem.AraTutar = BirimFiyat;
      kalem.Kdv = Tutar * oranconvert - BirimFiyat;
      // kalem.Kdv=kalem.Kdv;
      kalem.Miktar = Miktar;
      kalem.siparisID = SiparisID;
      kalem.BirimFiyat = BirimFiyat;
      kalem.DepoKodu = 0;
      kalem.IslemTuru = 1;
      kalem.Sign = 0;
      kalem.SlsMan = islemyapan;
      kalem.Tutar = Tutar * oranconvert;
      kalem.StokKartID = StokKartID;
      kalem.NetFiyat = Tutar * oranconvert;
      kalem.UrunName = UrunAdi;
      kalem.IskontoOran1 = 0;
      kalem.IskontoOran2 = 0;
      kalem.IskontoOran3 = 0;
      kalem.IskontoTutar = 0;
      kalem.IskontoluBirimFiyati = 0;
      kalem.KdvOran = KdvOran;
      kalem.SIPARIS_DURUM_ID = SipariDurumID;
      this.add(kalem).then(a => {
        resolve(a);
      }).catch(x => {
        reject(x);
      })

    });
  }
  satinAlmaDetayEkle_Temp(kaynakRef: number, itemref: number, miktar: number, urunAdi: string, kdv: number, siparisID: number, urunfiyati: number, urunmaliyet: number, siparisdurumid: number, islemyapan: string,kalan:number) {
    return new Promise((resolve, reject) => {
      // var eklenecekFiyat: number = 0;
      // var siparisDetaySecenekleriJSON = "";
      // var aciklama = "";
      // var seceneklerString = "";

      this.getAll({ siparisID: siparisID, StokKartID: itemref }).then(b => {
        var sonuc = <any>b;

        if (sonuc.length > 0) {
          sonuc[0].Miktar = sonuc[0].Miktar + parseFloat(miktar.toString());
          this.miktarGuncelle(sonuc[0]).then(a => {
            resolve(a);
          }).catch(x => {
            reject(x);
          })
        }
        else {
          var artutar: number = 0;
          var kdvlcl: number = 0;
          artutar = urunfiyati - (urunfiyati * kdv / 100);
          kdvlcl = urunfiyati * kdv / 100;
          var siparisDetay = new NL_Siparis();
          siparisDetay.CariKartID = kaynakRef;
          siparisDetay.Kdv = parseFloat(kdvlcl.toFixed(2));
          siparisDetay.Miktar = miktar;
          siparisDetay.siparisID = siparisID;
          siparisDetay.BirimFiyat = urunfiyati;
          siparisDetay.DepoKodu = 0;
          siparisDetay.IslemTuru = 1;
          siparisDetay.Sign = 0;
          siparisDetay.SlsMan = islemyapan;
          siparisDetay.Tutar = miktar * urunfiyati;
          siparisDetay.StokKartID = itemref;
          siparisDetay.Maliyet = urunmaliyet;
          siparisDetay.NetFiyat = urunfiyati;
          siparisDetay.UrunName = urunAdi;
          siparisDetay.SIPARIS_DURUM_ID = siparisdurumid;
          siparisDetay.CariKartID = 1;
          siparisDetay.IskontoOran1 = 0;
          siparisDetay.IskontoOran2 = 0;
          siparisDetay.IskontoOran3 = 0;
          siparisDetay.IskontoTutar = 0;
          siparisDetay.AraTutar = parseFloat(artutar.toFixed(2));
          siparisDetay.KdvOran = 18;
          siparisDetay.Kalan=kalan;

          this.add(siparisDetay).then(a => {
            resolve(a);
          }).catch(x => {
            reject(x);
          })
        }
      });

    });
  }


  miktarGuncelle(detay: NL_Siparis) {
    return new Promise((res, err) => {
      this.execRawQueryWithParams("update NL_Siparis set Miktar = ? where ID = ?", [detay.Miktar, detay.ID]).then(a => {
        res(a);
      }).catch(x => {
        err(x);
      })

    })
  }
  birimFiyatGuncelle(detay: NL_Siparis) {
    return new Promise((res, err) => {
      this.execRawQueryWithParams("update NL_Siparis set BirimFiyat = ? where ID = ?", [detay.BirimFiyat, detay.ID]).then(a => {
        res(a);
      }).catch(x => {
        err(x);
      })
      this.execRawQueryWithParams("update NL_Siparis set Tutar = ? where ID = ?", [detay.Tutar, detay.ID]).then(a => {
        res(a);
      }).catch(x => {
        err(x);
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/bll/bll-siparis-detay.ts